module.exports = __webpack_public_path__ + "assets/img/btn_go_exchange.a424a7e3.png";